export default function StickyMenu(selector = "") {
  document.addEventListener("scroll", () => {
    const element = document.querySelector(selector);
    const headerReserved = document.querySelector('.header-reserved');
    if (element) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        element.classList.add("fixed-header");
        headerReserved.classList.add("fixed-header");
      } else {
        element.classList.remove("fixed-header");
        headerReserved.classList.remove("fixed-header");
      }
    }
  });
}
